export default __webpack_public_path__ + "static/media/level2Wired.7a22473f.svg";